import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const WITHOUT_PILATES = ['Llegar a clase sin un plan claro.', 'Dudar cuando un alumno necesita una adaptación.', 'Perder horas preparando una sola clase.', 'Limitarte a lo que ya conocés.', 'No saber cómo atraer más alumnos.'];
const WITH_PILATES = ['Enseñar con un sistema paso a paso.', 'Resolver cualquier situación con seguridad.', 'Ahorrar tiempo con clases y recursos listos.', 'Especializarte en Mat, Reformer, Gravity y Wunda Chair.', 'Aprender a posicionarte y hacer crecer tu carrera.'];
interface ComparisonCardProps {
  title: string;
  items: string[];
  variant: 'without' | 'with';
}
export function PilatesComparison() {
  return <section className="w-full bg-beige-deep py-20" data-id="element-139" data-mp="kanf6f8rs3mg">
      <div className="mx-auto max-w-3xl px-6" data-id="element-140" data-mp="3ixt2e9bbxt9j">
        <div className="mx-auto max-w-2xl text-center" data-id="element-141" data-mp="3ix00pmr89ty9">
          <p className="inline-flex items-center gap-2 rounded-full border border-brown-light/25 bg-white/70 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-142" data-mp="3nwmepyevre84">
            <span className="h-1.5 w-1.5 rounded-full bg-brown-light" data-id="element-143" data-mp="1xa1ehyhpc146" />
            LA REAL DIFERENCIA
          </p>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-144" data-mp="1sgysqcj61vyj">
            Con Pilates Resuelto vs Sin
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-145" data-mp="1ji4qo6n2gddl">
            Cambiá la incertidumbre de improvisar por la tranquilidad de saber qué hacer.
          </p>
        </div>

        <div className="mt-10 space-y-5" data-id="element-146" data-mp="19kgsf6q94nqo">
          <ComparisonCard title="Sin Pilates Resuelto" items={WITHOUT_PILATES} variant="without" data-id="element-147" data-mp="19li8xqq1e2fs" />
          <ComparisonCard title="Con Pilates Resuelto" items={WITH_PILATES} variant="with" data-id="element-148" data-mp="33xq9pkp1hdjh" />
        </div>
      </div>
    </section>;
}
function ComparisonCard({
  title,
  items,
  variant
}: ComparisonCardProps) {
  const isWithPilates = variant === 'with';
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5
  }} className={`rounded-3xl p-7 sm:p-9 ${isWithPilates ? 'bg-brown-dark text-beige shadow-xl shadow-brown-dark/15' : 'border border-brown-light/20 bg-white text-brown-dark'}`} data-id="element-149" data-mp="120y2egilbu8l">
      <div className="flex items-center gap-3" data-id="element-150" data-mp="1kxh96z5x961z">
        <div className={`flex h-10 w-10 items-center justify-center rounded-full ${isWithPilates ? 'bg-brown-light text-beige' : 'bg-beige-deep text-brown-light'}`} data-id="element-151" data-mp="16yzmn4rr5zln">
          {isWithPilates ? <CheckIcon className="h-5 w-5" strokeWidth={3} data-id="element-152" data-mp="3ro6ubq499mrn" /> : <XIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-153" data-mp="jglhcy37sv0" />}
        </div>
        <h3 className="font-serif text-2xl font-semibold sm:text-3xl" data-id="element-154" data-mp="3o7au6v9pg444">{title}</h3>
      </div>

      <ul className="mt-6 space-y-4" data-id="element-155" data-mp="3k5phpb131rug">
        {items.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed sm:text-base" data-id="element-156" data-mp="3k5ftnszllure">
            {isWithPilates ? <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brown-light" strokeWidth={2.75} data-id="element-157" data-mp="3t6nd54xggr1f" /> : <XIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brown-light" strokeWidth={2.25} data-id="element-158" data-mp="35g1icfcgp39d" />}
            <span className={isWithPilates ? 'text-beige/85' : 'text-brown-dark/75'} data-id="element-159" data-mp="30iris6vczb7t">{item}</span>
          </li>)}
      </ul>
    </motion.article>;
}